import React from "react";

import OnePanel from "./OnePanel";
import Text from "./Text";

const OperationalAnalysis = () => (
  <OnePanel title="Operational Analysis">
    <Text>
      This section we are going to review Head of Operation decisions and how
      they impact your Income Statement.
    </Text>
  </OnePanel>
);

export default OperationalAnalysis;



// WEBPACK FOOTER //
// ./src/components/analysis/OperationalAnalysis.js